import {
  MDSDotPulseLoaderProps,
  MDSDotPulseLoaderKind,
  MDSDotPulseLoaderSize,
} from "./dot-pulse-loader.types";
import { StyledWrapper, StyledDotLoader } from "./dot-pulse-loader.styles";

export const MDSDotPulseLoader = ({
  kind = MDSDotPulseLoaderKind.Dark,
  size = MDSDotPulseLoaderSize.Medium,
  className,
}: MDSDotPulseLoaderProps) => {
  return (
    <StyledWrapper className={className}>
      <StyledDotLoader kind={kind} size={size} />
    </StyledWrapper>
  );
};
